import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from "recharts";
  
  export default function StackedBarChartPro({ data }) {

    const CustomTooltip = ({ active, payload, label }) => {

      // console.log(payload);
      if (active && payload && payload.length) {
        return (
          <div className="custom-tooltip">
            <span style={{display: 'block'}}>{`Items Received On Time: ${payload[0]?.value}`}</span>
            <span style={{display: 'block'}}>{`Received With Delay: ${payload[1]?.value}`}</span>
            {/* <span style={{display: 'block'}}>{`${label}`}</span> */}
            {/* <span style={{display: 'block'}}>{`${payload[0]?.payload?.data1Lable}: ${payload[0]?.value}`}</span> */}
            {/* <p className="intro">{getIntroOfPage(label)}</p>
            <p className="desc">Anything you want can be displayed here.</p> */}
          </div>
        );
      }
    
      return null;
    };

    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="order_month" />
          <YAxis />
          {/* <Tooltip /> */}
          <Tooltip content={<CustomTooltip />} cursor={{fill: 'transparent'}} />
          <Legend
                    payload={[
                    { value: "Items Received On Time", id: "reason_1", color: '#b695ff' },
                    { value: "Received With Delay", id: "reason_2", color: '#f9db7b' },               
                    ]}
                />
          <Legend />
          <Bar dataKey="total_items_post_cancellation" fill="#b695ff" />          
          <Bar dataKey="inwarded_delayed" fill="#f9db7b" />

          {/* <Bar dataKey="recievedOnTime" fill="#ffa9ce" /> */}

        </BarChart>
      </ResponsiveContainer>
    );
  }
